jQuery( function($){

    $('.js-slimScroll').each(function () {
        var $this = $(this);

        $this.slimScroll({
            color: '#fff',
            size: '5px',
            height: 'auto',
            alwaysVisible: true,
            railVisible: true,
            railColor: '#fff',
            railOpacity: 0.25,
            // distance: '15px',

            // wheelStep: 10,
            allowPageScroll: true,
            // disableFadeOut: false
        }).parent().css({
            // background: '#237FAD',
            // border: '2px dashed #184055'
        });
    })

});
